import { OpaccGeneral } from './classes/opacc.class.general.js';
import { OpaccLanguage } from './classes/opacc.class.language.js';
import { OpaccSocialMedia } from './classes/opacc.class.socialmedia.js';
import { OpaccTooltip } from './classes/opacc.class.tooltip.js';


/**
 * Clientseitige Funktionalität im Modul "General"
 *
 * @module general
 */

export const opaccGeneralPlugin = new OpaccGeneral();
export const opaccLanguagePlugin = new OpaccLanguage();
export const opaccSocialMediaPlugin = new OpaccSocialMedia();
export const opaccTooltipPlugin = new OpaccTooltip();